module.exports = __webpack_public_path__ + "static/img/defaultGraph.5b3e5ac5.png";